import loadable from '@loadable/component';
import classnames from 'classnames';
import React, { Fragment } from 'react';
import SVG from 'react-inlinesvg';

import styles from './FileSection.module.scss';

const AppTooltip = loadable(
  () => import('@krea/common/shared-components/tooltip'),
);

const FileSectionAction = ({
  icon,
  title,
  className,
  iconClassName,
  onClick,
}) => {
  return (
    <Fragment>
      <AppTooltip content={title}>
        <div
          className={classnames(
            styles.button,
            'd-flex justify-content-center align-items-center ml-2 rounded-circle',
            className,
          )}
          onClick={onClick}
        >
          <div
            className={classnames(
              styles.buttonIcon,
              'position-relative',
              iconClassName,
            )}
          >
            <SVG className="position-absolute w-100 h-100" src={icon} />
          </div>
        </div>
      </AppTooltip>
    </Fragment>
  );
};

export default FileSectionAction;
